import React from "react";
import { useSelector } from "react-redux";
import AdminSettings from "../../pages/admin/Settings/Settings";
import InstructorSetting from "../../pages/instructor/Settings/Settings";
import StudentSettings from "../../pages/student/Settings/Settings";

const RoleBasedSettings = () => {
  const auth = useSelector((state) => state.auth);
  const userRole = auth?.role?.toLowerCase();

  switch (userRole) {
    case 'admin':
      return <AdminSettings />;
    case 'instructor':
      return <InstructorSetting />;
    case 'student':
      return <StudentSettings />;
    default:
      return <StudentSettings />; // Default fallback
  }
};

export default RoleBasedSettings;
